import { useDisconnect, useSignMessage } from "wagmi";
import { useRecoilState } from "recoil";
import { userSmartAccount } from "./RecoilAtom";

const useCheckTokenExpiration = () => {
    const { disconnect } = useDisconnect();
    const { reset: resetSignMessage } = useSignMessage();
    const [, setSmartAccount] = useRecoilState(userSmartAccount);

    const disconnectWallet = async () => {
        resetSignMessage();
        disconnect();
        setSmartAccount(null);
        localStorage.removeItem("connectorId");
        localStorage.removeItem("chain");
        localStorage.removeItem("flag");
        localStorage.removeItem("userId");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("lastAccount");
        localStorage.removeItem("sign");
        localStorage.removeItem("sessionExpiryTime");
    };

    return { disconnectWallet };
};

export default useCheckTokenExpiration;
